module.exports = __webpack_public_path__ + "135a922ef37d3aacbcd6061faefa1d8a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_2-660.webp.png
// module id = 297
// module chunks = 0